export default __webpack_public_path__ + "static/hepato-zasilvat-dirty-filter-72dd35ab1b53087c5d8be4460d3aba94.jpg";